import styled from 'styled-components'

const Wrapper = styled.div`
  margin-top: 0.5rem;
  display: flex;
  align-items: center;

  input {
    width: 60%;
  }

  p {
    padding: 0;
    margin: 0;
    overflow-wrap: break-word;
    max-width: 250px;
  }

  .icon {
    font-size: 1rem;
    margin-right: 1rem;
    display: flex;
    align-items: center;
    svg {
      color: var(--grey-400);
    }
  }
  .text {
    letter-spacing: var(--letterSpacing);
  }
  .headline {
    font-size: 20px;
  }
`
export default Wrapper
